import { CheckIcon, XMarkIcon } from '@heroicons/react/16/solid';
import { Button, Modal } from 'react-daisyui';
import { useTeamContext } from '../../Team.context';

export default function UserAdded() {
  const { showExistentUserModal, toggleExistentUserModal, addUserFormik } =
    useTeamContext();
  return (
    <Modal
      open={showExistentUserModal}
      className="UserCreatedModal"
      backdrop={true}
      responsive={true}
    >
      <Modal.Header className="UserCreatedModal__Header">
        <h1>Usuario agregado 🎉</h1>
        <Button
          color="ghost"
          size="sm"
          shape="square"
          onClick={() => {
            toggleExistentUserModal(false);
            addUserFormik?.resetForm();
          }}
        >
          <XMarkIcon className="UserCreatedModal__CloseIcon" />
        </Button>
      </Modal.Header>
      <Modal.Body className="grid justify-items-center">
        <div className=" mt-4 w-14 h-14 rounded-full bg-green-100">
          <CheckIcon className={'text-green-200 ml-1 pt-2 h-12 w-12'} />
        </div>
        <p className="text-center text-md text-green-400 mt-4">{`Se ha creado el usuario de manera correcta, la cuenta es ${addUserFormik?.values.email}`}</p>
        <p className="text-center text-sm text-gray-500 mt-4">
          Este usuario ya tiene una cuenta de leadsales, pídele que inicie
          sesión con su contraseña original para que pueda ver tu workspace.
        </p>
        <div className="flex flew-row space-x-4 mt-4"></div>
      </Modal.Body>
      <Button
        color="primary"
        fullWidth
        onClick={() => {
          toggleExistentUserModal(false);
          addUserFormik?.resetForm();
        }}
      >
        Entendido
      </Button>
    </Modal>
  );
}
